import { PoliJobsMarketApi, StudentYearEnum } from "../Api";
import { getAuthConfiguration } from "./configuration";
import { arrayParamAjust } from "../utils/dataUtils";

const AuthPoliJobsMarketApiFactory = () =>
	new PoliJobsMarketApi(getAuthConfiguration());

export interface StudentCVAccessProps {
	search?: string;
	page?: number;
	pageSize?: number;
	Year?: Array<string>; //years
	Faculty?: Array<string>; //faculties
}

export const getAllStudentCVsForCompany = (
	companyId: string,
	props: StudentCVAccessProps
) => {
	const {
		search: namePattern,
		page,
		pageSize,
		Year: years,
		Faculty: faculties,
	} = props;

	return AuthPoliJobsMarketApiFactory().apiPoliJobsMarketGetAllStudentCVsForCompanyCompanyIdGet(
		{
			companyId,
			namePattern,
			page,
			pageSize,
			years: arrayParamAjust(
				years?.map((y) => StudentYearEnum[y as keyof typeof StudentYearEnum])
			),
			faculties: arrayParamAjust(faculties),
		}
	);
};

export const getStudentCVAccessFilters = (
	companyId: string,
	language: string
) => {
	return AuthPoliJobsMarketApiFactory().apiPoliJobsMarketGetStudentCvAccessFiltersCompanyIdGet(
		{
			companyId,
			language,
		}
	);
};

export const generateStudentAccessQRCodePdf = (companyId: string) => {
	return AuthPoliJobsMarketApiFactory().apiPoliJobsMarketGenerateStudentAccessQRCodePdfCompanyIdGet(
		{
			companyId,
		}
	);
};

export const generateStudentAccessQRCodePng = () => {
	return AuthPoliJobsMarketApiFactory().apiPoliJobsMarketGenerateStudentAccessQRCodePngGet();
};

export const shareCVAccess = (companyId: string) => {
	return AuthPoliJobsMarketApiFactory().apiPoliJobsMarketShareCVAccessCompanyIdPost(
		{
			companyId,
		}
	);
};
